import { memo } from 'react'

// Component
import { Col, Row } from 'react-bootstrap'
import { m } from "framer-motion"
import { PropTypes } from "prop-types";



// css
import "../../Assets/scss/components/_rotatebox.scss"

const RotateBox = (props) => {

    if (props?.data?.length <= 0) return (<><h6>No data found...</h6></>)
    return (
        <>
            <Row className={`${props.grid}${props.className ? ` ${props.className}` : ""}`}>
                {
                    props?.data?.map((item, i) => {
                        return (
                            <Col key={i}>
                                <m.div
                                    className="rm-rotate-box text-center"
                                    initial={{ opacity: 0, transform: "perspective(400px) rotateY(90deg)" }}
                                    whileInView={{ opacity: 1, transform: "perspective(400px) rotateY(0deg)" }}
                                    viewport={{ once: true }}
                                    transition={{ type: "spring", stiffness: 100, duration: 1 }}
                                >
                                    <div className="flipper  to-left">
                                        <div className="thumb-wrap ">
                                            <div className="card-side border-2 front overflow-hidden rounded-[4px] h-[350px] lg:h-[350px]" >
                                                <div className='flex justify-center mt-[20px]'>
                                                    <img
                                                        src={` https://kera.enfonoerp.com${item?.image}` || "/images/default-avatar.jpg"}
                                                        className="w-[150px] h-[150px] rounded-full border-2 object-cover"
                                                        alt={item?.full_name}
                                                    />
                                                </div>
                                                <div className="content-wrap p-[10px] mt-[30px] ">
                                                    <span className="text-black text-lg tracking-[1px] uppercase font-serif inline-block font-medium mb-[10px]">{item?.full_name}</span>
                                                    <span className="text-black opacity-60 text-md uppercase tracking-[.5px] font-serif block">{item?.designation}</span>
                                                </div>
                                            </div>
                                            <div className="card-side border-2 back rounded-[4px] overflow-hidden">
                                                <div className="absolute w-full h-full top-0 left-0 bg-[white]"></div>
                                                <div className="content-wrap flex flex-col items-center p-[30px] lg:px-[30px] md:px-[40px] xs:p-[30px]">
                                                    <span className="text-black text-xmd tracking-[1px] font-medium uppercase font-serif block mb-[10px]">{item?.full_name}</span>
                                                    <i className={`fa-solid fa-envelope text-[25px] text-black mb-[10px] inline-block`}></i>
                                                    <p className="text-black text-[15px] opacity-70 mb-[25px]">{item?.email_id}</p>
                                                    <i className={`fa-solid fa-phone text-[25px] text-black mb-[10px] inline-block`}></i>
                                                    <p className="text-black text-[15px] opacity-70  mb-[25px]">{item?.phone_no}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </m.div>
                            </Col>
                        )
                    })
                }
            </Row>
        </>
    )
}



RotateBox.propTypes = {
    className: PropTypes.string,
    grid: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.exact({
            img: PropTypes.string,
            title: PropTypes.string,
            subtitle: PropTypes.string,
            content: PropTypes.string,
            btnTitle: PropTypes.string,
            btnLink: PropTypes.string,
            icon: PropTypes.string,
        })
    )
}

export default memo(RotateBox)
